import { render, staticRenderFns } from "./EditSecurity.vue?vue&type=template&id=0ebe0f0c&scoped=true"
import script from "./EditSecurity.vue?vue&type=script&lang=js"
export * from "./EditSecurity.vue?vue&type=script&lang=js"
import style0 from "./EditSecurity.vue?vue&type=style&index=0&id=0ebe0f0c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ebe0f0c",
  null
  
)

export default component.exports